import { render } from "./Remitos.vue?vue&type=template&id=2f7e049e&scoped=true"
import script from "./Remitos.vue?vue&type=script&lang=js"
export * from "./Remitos.vue?vue&type=script&lang=js"

import "./Remitos.vue?vue&type=style&index=0&id=2f7e049e&scoped=true&lang=scss"

import exportComponent from "/builds/aplicaciones_mides/pat_qr/QRreader/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7e049e"]])

export default __exports__